/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type AtualizarMeDtoUfCrmv = typeof AtualizarMeDtoUfCrmv[keyof typeof AtualizarMeDtoUfCrmv] | null;


export const AtualizarMeDtoUfCrmv = {
  AC: 'AC',
  AL: 'AL',
  AP: 'AP',
  AM: 'AM',
  BA: 'BA',
  CE: 'CE',
  DF: 'DF',
  ES: 'ES',
  GO: 'GO',
  MA: 'MA',
  MT: 'MT',
  MS: 'MS',
  MG: 'MG',
  PA: 'PA',
  PB: 'PB',
  PR: 'PR',
  PE: 'PE',
  PI: 'PI',
  RJ: 'RJ',
  RN: 'RN',
  RS: 'RS',
  RO: 'RO',
  RR: 'RR',
  SC: 'SC',
  SP: 'SP',
  SE: 'SE',
  TO: 'TO',
} as const;
